<template>
    <div class="users" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="page-header">
            <h1 class="page-title">{{ $t("messages.users") }}</h1>
        </div>

        <div class="content">
            <table class="users-table table users-create">
                <thead>
                    <tr>
                        <th class="user-name name">{{ $t("messages.name") }}</th>
                        <th class="email">{{ $t("messages.email") }}</th>
                        <th class="password">{{ $t("messages.password") }}</th>
                        <th class="available-campaigns">
                            {{ $t("messages.available_campaigns") }}
                        </th>
                        <th class="role">{{ $t("messages.access_level") }}</th>
                        <th class="actions"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>

                        <td class="name">
                            <input v-model="createUserName" name="user-name" autocomplete="new-name"
                                :placeholder="$t('messages.name')" type="text" />
                        </td>
                        <td class="email">
                            <input v-model="createUserEmail" name="user-email" autocomplete="new-email"
                                :placeholder="$t('messages.email')" type="text" />
                        </td>
                        <td class="password">
                            <input v-model="createUserPassword" name="user-password" autocomplete="new-password"
                                :placeholder="$t('messages.password')" type="password" />
                        </td>
                        <td class="available-campaigns">
                            <el-popover placement="bottom-start" :width="320" trigger="click">
                                <template #reference>
                                    <el-button type="default" plain>
                                        {{ createUserCampaigns.length > 0 ? `${$t('messages.selected')}:
                                        ${createUserCampaigns.length}` :
                                            $t('messages.select_campaigns') }}
                                    </el-button>
                                </template>
                                <div class="campaigns-selector">
                                    <div class="campaigns-header">
                                        <span>{{ $t('messages.select_campaigns_title') }}</span>
                                        <el-button type="text" size="small" @click="createUserCampaigns = []">
                                            {{ $t('messages.clear') }}
                                        </el-button>
                                    </div>
                                    <el-checkbox-group v-model="createUserCampaigns">
                                        <div v-for="campaign in campaignOptions" :key="campaign.id"
                                            class="campaign-item">
                                            <el-checkbox :label="campaign.id">{{ campaign.label }}</el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </el-popover>
                        </td>
                        <td class="role">
                            <ul>
                                <li v-for="row in roles" :key="row.id">
                                    <input :id="'create-user-role-' + row.id" v-model="createUserRole" :value="row.id"
                                        type="radio" />
                                    <label :for="'create-user-role-' + row.id" class="radio">{{ $t(`messages.roles.${row.role}`) || row.role }}</label>
                                </li>
                            </ul>
                        </td>
                        <td class="actions">
                            <div class="actions-content">
                                <label @click="createUser" class="save-label"
                                    v-tippy="{ content: $t('messages.save'), theme: 'light' }"></label>
                                <label @click="cancelCreateUser()" class="cancel-label"
                                    v-tippy="{ content: $t('messages.cancel_changes'), theme: 'light' }"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="content">
            <div class="filter">
                <input v-model="filters.user.value" type="text" name="filter" class="filter-input"
                    :placeholder="$t('messages.start_typing_name_id_email')" />
            </div>

            <table class="users-table table">
                <thead>
                    <tr>
                        <th class="user-name name">{{ $t("messages.name") }}</th>
                        <th class="email">{{ $t("messages.email") }}</th>
                        <th class="password"></th>
                        <th class="available-campaigns">{{ $t("messages.available_campaigns") }}</th>
                        <th class="role">{{ $t("messages.access_level") }}</th>
                        <th class="actions"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="row in filteredUsers" :key="row.id">

                        <td class="name">
                            <div v-if="editUserId !== row.id" class="name-info">
                                <div class="name">{{ row.name }}</div>
                                <div class="info">ID: {{ row.id }}</div>
                            </div>
                            <input v-else v-model="editUserName" :placeholder="$t('messages.name')" type="text" />
                        </td>
                        <td class="email">
                            <div v-if="editUserId !== row.id">{{ row.email }}</div>
                            <input v-else v-model="editUserEmail" :placeholder="$t('messages.email')" type="text" />
                        </td>
                        <td class="password"></td>
                        <td class="available-campaigns">
                            <div v-if="editUserId !== row.id" v-tippy="{
                                content: getTooltipCampaigns(row),
                                allowHTML: true,
                                interactive: true,
                                theme: 'light',
                                minWidth: '300px',
                            }">
                                {{ $t('messages.available_campaigns') }}:
                                {{ row.campaigns.length }}
                            </div>
                            <el-popover v-else placement="bottom-start" :width="320" trigger="click">
                                <template #reference>
                                    <el-button type="default" plain>
                                        {{ editUserCampaigns.length > 0 ? `${$t('messages.selected')}:
                                        ${editUserCampaigns.length}` :
                                            $t('messages.select_campaigns') }}
                                    </el-button>
                                </template>
                                <div class="campaigns-selector">
                                    <div class="campaigns-header">
                                        <span>{{ $t('messages.select_campaigns_title') }}</span>
                                        <el-button type="text" size="small" @click="editUserCampaigns = []">
                                            {{ $t('messages.clear') }}
                                        </el-button>
                                    </div>
                                    <el-checkbox-group v-model="editUserCampaigns">
                                        <div v-for="campaign in campaignOptions" :key="campaign.id"
                                            class="campaign-item">
                                            <el-checkbox :label="campaign.id">{{ campaign.label }}</el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </el-popover>
                        </td>
                        <td class="role">
                            <div v-if="editUserId !== row.id">
                                {{ $t(`messages.roles.${roles.find((o) => o.id === row.role_id)?.role}`) || roles.find((o) => o.id === row.role_id)?.role || row.role_id }}
                            </div>
                            <ul v-else>
                                <li v-for="row in roles" :key="row.id">
                                    <input :id="'edit-user-role-' + row.id" v-model="editUserRole" :value="row.id"
                                        type="radio" />
                                    <label :for="'edit-user-role-' + row.id" class="radio">{{ $t(`messages.roles.${row.role}`) || row.role }}</label>
                                </li>
                            </ul>
                        </td>
                        <td class="actions">
                            <div class="actions-content">
                                <label v-if="editUserId !== row.id" @click="editUser(row)" class="edit-label" v-tippy="{
                                    content: $t('messages.edit'),
                                    theme: 'light',
                                }"></label>
                                <label v-if="editUserId !== row.id" @click="deleteUser(row.id)" class="delete-label"
                                    v-tippy="{ content: $t('messages.delete'), theme: 'light' }"></label>
                                <label v-if="editUserId === row.id" @click="saveUser(row)" class="save-label"
                                    v-tippy="{ content: $t('messages.save'), theme: 'light' }"></label>
                                <label v-if="editUserId === row.id" @click="cancelEditUser()" class="cancel-label"
                                    v-tippy="{
                                        content: $t('messages.cancel_changes'),
                                        theme: 'light',
                                    }"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { parseApiError } from "../utils/apiError";

export default {
    name: "Users",
    props: ["dependent_users", "campaigns", "roles"],
    data() {
        return {
            createUserName: null,
            createUserEmail: null,
            createUserPassword: null,
            createUserCampaigns: [],
            createUserRole: null,

            editUserId: null,
            editUserName: null,
            editUserEmail: null,
            editUserCampaigns: [],
            editUserRole: null,

            active_li: null,
            fullscreenLoading: false,

            filters: {
                user: {
                    value: "",
                    keys: ["name", "id", "email"],
                },
            },
        };
    },
    computed: {
        campaignOptions() {
            return this.campaigns.map((campaign) => ({
                id: campaign.id,
                label: campaign.campaign,
            }));
        },
        filteredUsers() {
            if (!this.filters.user.value) {
                return this.dependent_users;
            }

            const query = this.filters.user.value.toLowerCase();
            return this.dependent_users.filter(user => {
                return (
                    user.name.toLowerCase().includes(query) ||
                    user.email.toLowerCase().includes(query) ||
                    user.id.toString().includes(query)
                );
            });
        },
    },
    methods: {
        createUser() {
            this.fullscreenLoading = true;
            axios({
                method: "post",
                url: "/users/create",
                data: {
                    name: this.createUserName,
                    email: this.createUserEmail,
                    password: this.createUserPassword,
                    campaigns: this.createUserCampaigns,
                    role: this.createUserRole,
                },
            })
                .then((response) => {
                    this.$notify({
                        title: this.$t('messages.completed_successfully'),
                        message: this.$t('messages.user_saved_successfully'),
                        type: "success",
                    });
                    window.location.href = response.data.redirect;
                })
                .catch((error) => {
                    this.fullscreenLoading = false;

                    const message =
                        error.response?.data?.error ||
                        Object.values(error.response?.data?.errors || {}).flat().join('\n') ||
                        this.$t('messages.failed_to_create_user');

                    this.$notify({
                        title: this.$t('messages.error_occurred'),
                        message,
                        type: "error",
                    });
                });
        },
        cancelCreateUser() {
            this.createUserName = null;
            this.createUserEmail = null;
            this.createUserPassword = null;
            this.createUserCampaigns = [];
            this.createUserRole = null;
        },
        editUser(item) {
            this.editUserId = item.id;
            this.editUserName = item.name;
            this.editUserEmail = item.email;
            this.editUserCampaigns = item.campaigns.map((a) => a.id);
            this.editUserRole = this.dependent_users.find(
                (o) => o.id === item.id
            ).role_id;
        },
        cancelEditUser() {
            this.editUserId = null;
            this.editUserName = null;
            this.editUserEmail = null;
            this.editUserCampaigns = [];
            this.editUserRole = null;
        },
        campaignIdsEqual(ids, campaigns) {
            const a = [...ids].map(Number).sort((x, y) => x - y);
            const b = campaigns.map((c) => Number(c.id)).sort((x, y) => x - y);
            return JSON.stringify(a) === JSON.stringify(b);
        },
        saveUser(item) {
            this.fullscreenLoading = true;

            const campaignsChanged = !this.campaignIdsEqual(this.editUserCampaigns, item.campaigns);

            if (
                this.editUserName !== item.name ||
                this.editUserEmail !== item.email ||
                campaignsChanged ||
                this.editUserRole !== item.role_id
            ) {
                axios({
                    method: "post",
                    url: "/users/edit",
                    data: {
                        id: this.editUserId,
                        name: this.editUserName,
                        email: this.editUserEmail,
                        campaigns: this.editUserCampaigns,
                        role: this.editUserRole,
                    },
                })
                    .then((response) => {
                        this.fullscreenLoading = false;

                        this.$notify({
                            title: this.$t('messages.completed_successfully'),
                            message: this.$t('messages.user_data_saved'),
                            type: "success",
                        });
                        item.name = this.editUserName;
                        item.email = this.editUserEmail;
                        item.campaigns = this.campaignOptions
                            .filter((c) => this.editUserCampaigns.includes(c.id))
                            .map((c) => ({ id: c.id, campaign: c.label }));
                        item.role_id = this.editUserRole;

                        this.editUserId = null;
                        this.editUserName = null;
                        this.editUserEmail = null;
                        this.editUserCampaigns = [];
                        this.editUserRole = null;
                    })
                    .catch((error) => {
                        this.fullscreenLoading = false;

                        this.$notify({
                            title: this.$t('messages.error_occurred'),
                            message: parseApiError(error, this.$t('messages.failed_to_save_user_data')),
                            type: "error",
                        });
                    });
            } else {
                this.fullscreenLoading = false;
                this.editUserId = null;
                this.editUserName = null;
                this.editUserEmail = null;
                this.editUserCampaigns = [];
                this.editUserRole = null;
            }
        },
        deleteUser(id) {
            this.$confirm(this.$t('messages.confirm_delete_user'), this.$t('messages.warning'), {
                confirmButtonText: this.$t('messages.delete'),
                cancelButtonText: this.$t('messages.cancel'),
                type: 'warning',
                confirmButtonClass: 'el-button--danger'
            }).then(() => {
                this.performDelete(id);
            }).catch(() => {
            });
        },
        performDelete(id) {
            this.fullscreenLoading = true;

            axios({
                method: "post",
                url: "/users/delete",
                data: { id: id },
            })
                .then((response) => {
                    this.$notify({
                        title: this.$t('messages.completed_successfully'),
                        message: this.$t('messages.user_deleted_successfully'),
                        type: "success",
                    });
                    window.location.href = response.data.redirect;
                })
                .catch((error) => {
                    this.fullscreenLoading = false;

                    this.$notify({
                        title: this.$t('messages.error_occurred'),
                        message: parseApiError(error, this.$t('messages.failed_to_delete_user')),
                        type: "error",
                    });
                });
        },
        getTooltipCampaigns(row) {
            return row.campaigns.map((c) => c.campaign).join("<br>");
        },
    },
};
</script>